module.exports = __webpack_public_path__ + "img/DOLLAR_SIGN.640b4bcf.svg";